import React, { Component } from 'react';
import { Box } from 'reflexbox';
import Form from 'components/Form';
import FormInput from 'components/Input';
import Button from 'components/Button';
import Loader from 'components/Loader';
import Text from 'components/Text';
import Validate from 'helpers/Validate';
import { getText } from 'helpers/i18n';

import PropTypes from 'prop-types';

export default class ClickDeliver extends Component {
    constructor(props) {
        super(props);
        this.zipInput = React.createRef();
        this.state = { zip: '' };
    }

    componentDidMount() {
        const { getCollectionZips, zips } = this.props;

        if (!zips) {
            getCollectionZips();
        }
    }

    onChange(name, value) {
        this.setState({ zip: value });
    }

    onClick() {
        const { placeDeliverOrder, products} = this.props;

        const validation = Validate(this.state.zip, this.zipInput.props.validator);

        if (!validation.valid) {
            this.zipInput.setState({
                validate: this.validateZip,
                validation: validation,
            });
            return;
        }

        placeDeliverOrder(this.state.zip, products);
    }

    render() {
        const { zips, error } = this.props;

        if (!zips) {
            return <Loader/>;
        }

        return (
            <Form className="clickdeliver">
                <Box mt={2}>
                    <label htmlFor="clickdeliver_postcode"><Text textKey="clickdeliver_postcode" /></label>
                    <FormInput
                        ref={input => { this.zipInput = input; }}
                        type="text"
                        id="clickdeliver_postcode"
                        name="clickdeliver_postcode"
                        ariaLabel={getText('clickdeliver_postcode')}
                        ariaRequired
                        onChange={this.onChange.bind(this)}
                        validator={{
                            list: zips,
                            errorMessage: {
                                list: 'clickdeliver_error',
                            },
                        }}
                    />
                    {error && error !== '' &&
                        <p className="error-helper">{error}</p>
                    }
                </Box>
                <Box mt={1}>
                    <Button
                        theme="primary"
                        type="submit"
                        text="clickdeliver_button"
                        onClick={this.onClick.bind(this)}
                        isLoading={this.props.processing}
                    />
                </Box>
            </Form>
        );
    }
}

ClickDeliver.propTypes = {
    zips: PropTypes.array,
    products: PropTypes.object.isRequired,
    processing: PropTypes.bool,
    getCollectionZips: PropTypes.func.isRequired,
    placeDeliverOrder: PropTypes.func.isRequired,
    error: PropTypes.any,
};
